import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
  path: "",
  redirect: "/home"
},
{
  path: "/",
  redirect: "/home"
},
// {
//   path: "/test",
//   name: "Test",
//   component: () => import('views/test.vue')
// },
{
  path: "/home",
  name: "Home",
  component: () => import('views/Home.vue'),
  meta: {
    title: 'Home - ASCancer - CNCB-NGDC'
  }
},
{
  path: "/humanbody",
  name: "HumanBody",
  component: () => import('components/main/HumanBody.vue'),
},

// Splicing Effect Page
{
  path: "/biofunc",
  name: "SplicingEffect",
  component: () => import('views/biofunc/SplicingEffect.vue'),
  meta: {
    title: 'Splicing Effect - ASCancer - CNCB-NGDC'
  }
},

// Browse Page
// {
//   path: "/browse",
//   name: "Browse",
//   component: () => import('views/browse/Browse.vue')
// },
{
  path: '/browse/knowledge',
  name: 'Knowledge',
  component: () => import('views/browse/Knowledge.vue'),
  meta: {
    title: 'Browse - CASE - ASCancer - CNCB-NGDC'
  }
},
{
  path: "/browse/knowledge/details",
  name: "Details",
  component: () => import('views/browse/Details.vue'),
  meta: {
    title: 'CASE - Details - ASCancer - CNCB-NGDC'
  }
},
{
  path: '/browse/datasets',
  name: 'Datasets',
  component: () => import('views/browse/Datasets.vue'),
  meta: {
    title: 'Browse - CPSE - ASCancer - CNCB-NGDC'
  }
},

// Projects Page
{
  path: '/projects/tcga',
  name: 'TcgaMeta',
  component: () => import('views/projects/TcgaMeta.vue'),
  meta: {
    title: 'Projects - TCGA - ASCancer - CNCB-NGDC'
  }
},
{
  path: "/projects/tcga/:id",
  name: "TCGA",
  component: () => import('views/projects/TCGA.vue'),
  meta: {
    title: 'Projects - TCGA - ASCancer - CNCB-NGDC'
  }
},
{
  path: '/projects/gtex',
  name: 'GtexMeta',
  component: () => import('views/projects/GtexMeta.vue'),
  meta: {
    title: 'Projects - GTEx - ASCancer - CNCB-NGDC'
  }
},
{
  path: "/projects/gtex/:id",
  name: "GTEx",
  component: () => import('views/projects/GTEx.vue'),
  meta: {
    title: 'Projects - GTEx - ASCancer - CNCB-NGDC'
  }
},
{
  path: "/projects/geo",
  name: "GeoMeta",
  component: () => import('views/projects/GeoMeta.vue'),
  meta: {
    title: 'Projects - GEO - ASCancer - CNCB-NGDC'
  }
},
{
  path: "/projects/geo/:id",
  name: "GEO",
  component: () => import('views/projects/GEO.vue'),
  meta: {
    title: 'Projects - GEO - ASCancer - CNCB-NGDC'
  }
},
{
  path: '/projects/cell-atlas',
  name: 'CellTypeAtlas',
  component: () => import('views/projects/CellTypeAtlas.vue'),
  meta: {
    title: 'Projects - Cell Type Atlas - ASCancer - CNCB-NGDC'
  }
},

// {
//   path: '/dataset',
//   name: 'PanCancerSpliceEvent',
//   component: () => import('views/PanCancerSpliceEvent.vue')
// },
// {
//   path: '/splicevis1',
//   name: 'SpliceVisualization',
//   component: () => import('views/visualization/SpliceVisualization.vue')
// },
{
  path: '/splicevis',
  name: 'SpliceVis',
  component: () => import('views/visualization/SpliceVis.vue'),
  meta: {
    title: 'Visualize - ASCancer - CNCB-NGDC'
  }
},
{
  path: "/download",
  name: "Download",
  component: () => import('views/Download.vue'),
  meta: {
    title: 'Download - ASCancer - CNCB-NGDC'
  }
},
{
  path: "/download/mras",
  name: "DownloadMRAS",
  component: () => import('views/DownloadMRAS.vue'),
  meta: {
    title: 'Download MRAS - ASCancer - CNCB-NGDC'
  }
},
// {
//   path: "/statistic",
//   name: "Statistic",
//   component: () => import('views/Statistic.vue'),
// },
{
  path: "/tools",
  // if tools have a default child route, the name is unnecessary!
  name: "Tools",
  component: () => import('views/Tools.vue'),
  meta: {
    title: 'Toolkit - ASCancer - CNCB-NGDC'
  }
},
// {
//   path: '/tools/general',
//   name: 'General',
//   component: () => import('views/tools/General.vue')
// },
// {
//   path: '/tools/stage/gene',
//   name: 'StagePlotGene',
//   component: () => import('views/tools/StagePlotGene.vue')
// },
// {
//   path: '/tools/stage/transcript',
//   name: 'StagePlotIsoform',
//   component: () => import('views/tools/StagePlotIsoform.vue')
// },
{
  path: '/tools/stage/asevent',
  name: 'StagePlotEvent',
  component: () => import('views/tools/stage_survival/StagePlotEvent.vue'),
  meta: {
    title: 'Toolkit - StagePlot - ASCancer - CNCB-NGDC'
  }
},
// {
//   path: '/tools/survival/gene',
//   name: 'SurvivalPlotGene',
//   component: () => import('views/tools/SurvivalPlotGene.vue')
// },
// {
//   path: '/tools/survival/transcript',
//   name: 'SurvivalPlotIsoform',
//   component: () => import('views/tools/SurvivalPlotIsoform.vue')
// },
{
  path: '/tools/survival/asevent',
  name: 'SurvivalPlotEvent',
  component: () => import('views/tools/stage_survival/SurvivalPlotEvent.vue'),
  meta: {
    title: 'Toolkit - SurvivalPlot - ASCancer - CNCB-NGDC'
  }
},
{
  path: '/tools/spliceinter',
  name: 'SpliceInteraction',
  component: () => import('views/tools/SpliceInteraction.vue'),
  meta: {
    title: 'Toolkit - SplicePPI - ASCancer - CNCB-NGDC'
  }
},
{
  path: '/tools/splicedrug',
  name: 'SpliceDrug',
  component: () => import('views/tools/SpliceDrug.vue'),
  meta: {
    title: 'Toolkit - SpliceDrug - ASCancer - CNCB-NGDC'
  }
},
// Splicing Regualtion Network Page
{
  path: "/tools/regnet",
  name: "SpliceRegulationNetwork",
  component: () => import('views/tools/regulation-network/SpliceRegulationNetwork.vue'),
  meta: {
    title: 'Toolkit - SpliceRegNetwork - ASCancer - CNCB-NGDC'
  }
},
// Splice Regualtion Explorer Page
{
  path: "/tools/regexp",
  name: "SpliceRegulationExplorer",
  component: () => import('views/tools/regulation-explorer/SpliceRegulationExplorer.vue'),
  meta: {
    title: 'Toolkit - SpliceRegExplorer - ASCancer - CNCB-NGDC'
  }
},
{
  path: "/help",
  name: "Help",
  component: () => import('views/Help.vue'),
  meta: {
    title: 'Help - ASCancer - CNCB-NGDC'
  }
},
// {
//   path: "/help1",
//   name: "Help_v1",
//   component: () => import('views/Help_v1.vue')
// },
// {
//   path: "/searchresult",
//   name: "SearchResult",
//   component: () => import('views/SearchResult.vue')
// },
{
  path: "/search",
  name: "SearchResultByGene",
  component: () => import('views/search/SearchResultByGene.vue'),
  meta: {
    title: 'SearchGene - ASCancer - CNCB-NGDC'
  }
},
{
  path: "/error",
  name: "404",
  component: () => import('views/404.vue'),
  meta: {
    title: '404 - ASCancer - CNCB-NGDC'
  }
},
{
  path: '*',
  redirect: '/error'
},

{
  path: '/tools/wshy/gene2gene',
  name: 'GenePairCorrelation',
  component: () => import('views/tools/wshy/GenePairCorrelation.vue'),
},
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
